/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the FxIdWebFeaturesAuthTwitchConnectRequest interface.
 */
export function instanceOfFxIdWebFeaturesAuthTwitchConnectRequest(value) {
    if (!('Game' in value) || value['Game'] === undefined)
        return false;
    if (!('Code' in value) || value['Code'] === undefined)
        return false;
    return true;
}
export function FxIdWebFeaturesAuthTwitchConnectRequestFromJSON(json) {
    return FxIdWebFeaturesAuthTwitchConnectRequestFromJSONTyped(json, false);
}
export function FxIdWebFeaturesAuthTwitchConnectRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'Game': json['Game'],
        'Code': json['Code'],
    };
}
export function FxIdWebFeaturesAuthTwitchConnectRequestToJSON(json) {
    return FxIdWebFeaturesAuthTwitchConnectRequestToJSONTyped(json, false);
}
export function FxIdWebFeaturesAuthTwitchConnectRequestToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'Game': value['Game'],
        'Code': value['Code'],
    };
}
//# sourceMappingURL=FxIdWebFeaturesAuthTwitchConnectRequest.js.map